var _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvertIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.612 4.67-3.101-3.1a.865.865 0 0 0-.607-.252H7.268a.86.86 0 0 0-.859.86v12.026c0 .475.385.86.86.86h9.607c.736 0 .988-.357.988-.86V5.278a.853.853 0 0 0-.252-.607Z",
    fill: "#10F0A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.268 15.064a.86.86 0 0 1-.859-.86V2.178a.86.86 0 0 0 0 0v12.027c0 .475.385.86.86.86Zm11.414-.86V5.28c0-.446-.177-.873-.492-1.188l-3.1-3.1-.003-.002A1.683 1.683 0 0 0 13.906.5H7.268c-.926 0-1.677.751-1.677 1.677v12.027c0 .927.751 1.678 1.677 1.678h9.607c.488 0 .98-.118 1.344-.475.367-.36.463-.825.463-1.203Z",
    fill: "#8C92A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.444 9.277-1.93-.721a1.46 1.46 0 0 1-.83-1.414 1.448 1.448 0 0 1 1.312-1.452c.07-.01.12-.07.12-.141v-.385a.573.573 0 0 1 1.146 0v.357c0 .08.064.144.143.144h.716a.573.573 0 0 1 0 1.145h-1.79c-.5 0-.5.25-.5.332-.01.126.027.25.104.35l1.93.722c.54.258.869.82.829 1.417a1.448 1.448 0 0 1-1.311 1.449.143.143 0 0 0-.121.141v.386a.573.573 0 0 1-1.145 0v-.358a.143.143 0 0 0-.144-.143h-.716a.573.573 0 0 1 0-1.146h1.79c.501 0 .501-.25.501-.332a.514.514 0 0 0-.104-.35Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.591,
    cy: 14.409,
    r: 4.5,
    fill: "#8C92A4",
    stroke: "#fff",
    strokeWidth: 0.818
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.174 14.863a.41.41 0 0 0 0-.672l-1.941-1.345a.41.41 0 0 0-.642.336v.731H3.75a.614.614 0 1 0 0 1.227h1.84v.731c0 .33.372.525.643.337l1.94-1.345Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertIconGrey);
export default __webpack_public_path__ + "static/media/convert-icon-grey.417681d7e314a548575e95141a18ced3.svg";
export { ForwardRef as ReactComponent };